export default __webpack_public_path__ + "static/media/Sitting.6e15d1a0.svg";